module.exports = __webpack_public_path__ + "static/media/feature-5.0687e09b.png";